import { render, staticRenderFns } from "./WeedSlider.vue?vue&type=template&id=1c995a38&scoped=true&"
import script from "./WeedSlider.vue?vue&type=script&lang=js&"
export * from "./WeedSlider.vue?vue&type=script&lang=js&"
import style0 from "./WeedSlider.vue?vue&type=style&index=0&id=1c995a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c995a38",
  null
  
)

export default component.exports